<template>
  <div class="map-legends-block">
    <div class="map-legends-block__header">
      <h3 class="map-legends-block__title">
        {{ title }}
      </h3>
      <p
        v-if="activeFilterTypeOption === 'sentiment'"
        class="map-legends-block__subtitle"
      >
        {{ t('map_page.legends.sentiment_subtitle') }}
      </p>
    </div>

    <div class="map-legends-block__items">
      <template v-if="activeFilterTypeOption === 'importance'">
        <div
          v-for="item in importanceLegendItems"
          :key="item.name"
          class="map-legends-block__item"
        >
          <span
            class="map-legends-block__marker map-legends-block__marker--circle"
            :style="{ backgroundColor: item.color }"
          />
          <span class="map-legends-block__label">
            {{ t(`datetime_filter.importance.${item.name}`) }}
          </span>
        </div>
      </template>

      <template v-else>
        <div
          v-for="item in sentimentLegendItems"
          :key="item.name"
          class="map-legends-block__item"
        >
          <span
            class="map-legends-block__marker map-legends-block__marker--square"
            :style="{ backgroundColor: item.color }"
          />
          <span class="map-legends-block__label">
            {{ t(`datetime_filter.sentiment.${item.name}`) }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { t } from "@/controllerLK/AvalLocalization";
import { importanceList } from "@/const/importance.list";
import { sentimentList } from "@/const/sentimient.list";

const props = defineProps({
  activeFilterTypeOption: {
    type: String,
    required: true,
    validator: (value) => ["importance", "sentiment"].includes(value),
  },
});

const title = computed(() =>
  props.activeFilterTypeOption === "sentiment"
    ? t("map_page.legends.sentiment_title")
    : t("map_page.legends.importance_title")
);

const importanceLegendItems = computed(() =>
  Object.values(importanceList).filter(
    (item) => item.importance !== null && item.importance !== 0
  )
);

const sentimentLegendItems = computed(() =>
  Object.values(sentimentList)
);
</script>

<style lang="scss" scoped>
.map-legends-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 18px;
  background: var(--background-01);
  border-radius: 10px;
  box-shadow: 1px 2px 10px 0 var(--gray-gray50);

  &__header {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__title {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: var(--text-text-main);
  }

  &__subtitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--text-text-gray);
  }

  &__items {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__marker {
    width: 20px;
    height: 20px;

    &--circle {
      border-radius: 50%;
    }

    &--square {
      border-radius: 3px;
    }
  }

  &__label {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--text-text-main);
    white-space: nowrap;
  }
}
</style>
